//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import divSpan from '@/components/DivSpan';
export default {
  name: "list-arrange",
  data() {
    return {}
  },
  props: {
    data: "",
    isBlock: false,
    isBottom: false
  },
  created() {
  },
  components: {
    divSpan
  }
}



// WEBPACK FOOTER //
// ./src/components/temporary/list-arrange.vue